module.exports = __webpack_public_path__ + "assets/ic_bag.dc30558e.svg";